module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 40
// module chunks = 0